import React from "react";
import { observer } from "mobx-react";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";

interface MessageProps {}

const Message: React.FC<MessageProps> = withWSErrorContainer(
  observer(({}) => {
    return (
      <div>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum, modi
          rerum? Accusantium necessitatibus quae consectetur harum voluptatem.
          Quibusdam porro fuga totam ipsam, quam quas nostrum, ex quod
          asperiores minima quos?
        </p>
      </div>
    );
  })
);
export default Message;
